<h2 mat-dialog-title>{{ data.title }}</h2>
@if (data.content) {
  <mat-dialog-content class="mat-typography content">
    {{ data.content }}
    <span class="bold">{{ data.item ? data.item.name : '' }}</span
    >?

    {{ data.suffix }}
  </mat-dialog-content>
}
<mat-dialog-actions align="end">
  <app-button
    variant="stroked"
    color="neutral"
    mat-dialog-close>
    Cancel
  </app-button>
  <app-button
    (click)="confirm()"
    cdkFocusInitial>
    Confirm
  </app-button>
</mat-dialog-actions>
